import { Bootgrid } from "./bootgrid";
import { BootgridChangeType } from "./bootgridTypes";
import { postValueChange } from "./bootgridStateManagement"

/**
 * Initializes inline editable fields within bootgrid rows
 * Handles change events and posts data updates to the server
 */
export function initInlineEditable(this: Bootgrid) {
    var inputList = document.querySelectorAll('input.inline-editable') as NodeListOf<HTMLInputElement>;

    inputList.forEach(input => {
        input.addEventListener('change', () => {
            $(input).attr('value', input.value);
            let rows = (this.$bootgrid as any).bootgrid('getCurrentRows') as object[];
            const rowId = $(input).closest("tr").attr('data-row-id');
            const keyColumnName = this.$bootgrid.attr('data-luscinia-keycolumnname');
            let changedRow = rows.filter(row => row[keyColumnName] == rowId);
            let changedRowIndex = rows.findIndex(row => row[keyColumnName] == rowId);
            const changedPropertyName = $(input).attr('name');
            if (input.value != "") {
                changedRow[0][changedPropertyName] = input.value;
            } else {
                changedRow[0][changedPropertyName] = "0";
            }
            rows[changedRowIndex] = changedRow[0];
            const additionalFormData = this.bootgridManager.getPostValueChangeFormData(this, changedRow, BootgridChangeType.update, null, changedPropertyName);
            postValueChange.call(this, additionalFormData);
        });
    });
}